import React, { useState } from 'react';
import { BatchUpsert } from './BatchUpsert';
import { BLPList } from './BLPComponents';
import { EDIT_BOX_STATE } from '../../../../constants';

/**
 * BatchEditBox - Main container component for batch editing operations
 * Routes between BatchUpsert (create/edit) and BLPList based on editBoxState
 *
 * @param {string} field - Current field being edited (STATUS.CUT, STATUS.SEW, STATUS.PACK, STATUS.READY)
 * @param {Function} setField - Function to set the field being edited
 * @param {Object} selectedBatch - The selected batch object (null for create mode)
 * @param {Object} lot - The lot object
 * @param {number} editBoxState - Current state (EDIT_BOX_STATE.CREATE, EDIT, BLP)
 * @param {Function} setEditBoxState - Function to control edit box state
 * @param {Function} setReload - Function to trigger data reload
 * @param {boolean} isSaveLoading - Whether save operation is in progress
 * @param {Function} setIsSaveLoading - Function to control save loading state
 * @param {string} reportType - Type of report ('cutting' or 'sewing')
 */
export const BatchEditBox = ({
  field,
  setField,
  selectedBatch,
  lot,
  editBoxState,
  setEditBoxState,
  setReload,
  isSaveLoading,
  setIsSaveLoading,
  reportType
}) => {
  const [blpData, setBlpData] = useState([]);

  // Determine if we should show the batch form (create or edit)
  const showBatchForm = editBoxState === EDIT_BOX_STATE.CREATE || editBoxState === EDIT_BOX_STATE.EDIT;

  return (
    <div className="w-100 py-4 editing-container">
      <div className="row d-flex align-items-center justify-content-center">
        <div className="col-lg-9 col-11">
          {showBatchForm && (
            <BatchUpsert
              key={`upsert-${reportType}-${selectedBatch?.id || 'new'}`}
              lot={lot}
              setEditBoxState={setEditBoxState}
              selectedBatch={selectedBatch}
              field={field}
              setField={setField}
              setReload={setReload}
              setBlpData={setBlpData}
              dyeing={lot.dyeing}
              isSaveLoading={isSaveLoading}
              setIsSaveLoading={setIsSaveLoading}
              reportType={reportType}
            />
          )}
          {editBoxState === EDIT_BOX_STATE.BLP && (
            <BLPList
              data={blpData}
              selectedBatch={selectedBatch}
              setEditBoxState={setEditBoxState}
              setReload={setReload}
            />
          )}
        </div>
      </div>
    </div>
  );
};
